import {
  HStack,
  Menu,
  MenuButton,
  Text,
  Image,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { IDropdownItem } from "../_types_";

interface IProps {
  selectedVal?: string | number;
  data: IDropdownItem[];
  onChange?: (val: string | number) => void;
}
export default function Dropdown({ data, selectedVal, onChange }: IProps) {
  return (
    <Menu>
      <MenuButton w='full' bg="white" px="10px" py="10px" border="1px solid #f1f1f1">
        <HStack justifyContent='space-between'>
          <Text>
            {data.find((p) => p.value === selectedVal)?.lable || "---/---"}
          </Text>
          <Image src="./imgs/arrow-down.svg" />
        </HStack>
      </MenuButton>
      <MenuList>
        {data.map((item) => (
          <MenuItem
            key={item.value}
            onClick={() => onChange && onChange(item.value)}
          >
            {item.lable}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
